// let prefix = window.location.pathname.substr( 0, window.location.pathname.toLowerCase().lastIndexOf( "/extensions" ) + 1 );
// let config = {
// 	host: window.location.hostname,
// 	prefix: prefix,
// 	port: window.location.port,
// 	isSecure: window.location.protocol === "https:"
// };

// let appId = 'NP - Campaign Donations.qvf';

let config = {
	host: "sense-demo.qlik.com",
	prefix: "/",
	port: "443",
	isSecure: true
};

let appId = '95638a95-f74d-4f8c-bb4e-b51798a42878';

window.require.config({
	baseUrl: (config.isSecure ? "https://" : "http://" ) + config.host + (config.port ? ":" + config.port : "" ) + config.prefix + "resources"
});

window.require.config({
    context: 'extensions',
	baseUrl: "./extensions/"
});

export default new Promise((resolve) => {
    window.require( ["js/qlik"], function ( qlik ) {
        let app = qlik.openApp(appId, config);
        app.model.waitForOpen.promise.then(() => {
            resolve(app);
        });
        // window.require({context: 'extensions'}, ["IdevioMap/ideviomap", "IdevioAreaLayer/idevioarealayer"], function(ideviomap, idevioarealayer) {
        //     qlik.registerExtension('ideviomap', ideviomap);
        //     qlik.registerExtension('idevioarealayer', idevioarealayer);
        //     let app = qlik.openApp(appId, config);
        //     app.model.waitForOpen.promise.then(() => {
        //         resolve(app);
        //     });
        // });
    });
});



// WEBPACK FOOTER //
// ./qapp.js